// extracted by mini-css-extract-plugin
var _1 = "SeriesIcon-module__animatedBackground--Uj8yY";
var _2 = "SeriesIcon-module__archived--EQO4r";
var _3 = "SeriesIcon-module__bordered--W217a";
var _4 = "SeriesIcon-module__icon--lEKXo";
export { _1 as "animatedBackground", _2 as "archived", _3 as "bordered", _4 as "icon" }
